export const COLOR_POPOVER_BACK = 'rgba(26, 28, 30, 0.97);'

export const COLOR_BASE = '#272B2F'

export const COLOR_FOCUS_OUTLINE = '#0A4540'
